import { useNavigate } from "react-router-dom"
import logo from "../images/Mobile2Logo.svg"
import { useTranslation } from "react-i18next"
import { useContext } from "react"
import { PermissionContext } from "../contexts/PermissionContexts"


export const GuestFooter = () => {
    const { t } = useTranslation('common')
    const navigator = useNavigate()

    return (
        <div className="flex flex-col w-full text-gray-500 dark:text-gray-400">
            <div className="divider mt-0 pt-0"></div>
            <div className="md:px-10 px-3 py-5 flex flex-wrap justify-between gap-10 sm:grid sm:grid-cols-3">
                <FooterMobile2Main />

                <div className="order-3 sm:order-2 self-end min-w-max place-self-center flex flex-col justify-center items-center gap-1 text-xs w-full">
                    <span>Copyright M2 © 2025 FIBER SOFTWARE - FZCO</span>
                    <span>VENDSOFT SOFTWARE LTD© - info@vend.com.tr</span>
                </div>

                <div className="order-2 sm:order-3 min-w-32 justify-self-end flex flex-col gap-1">
                    <div className="h-[40px]"></div>
                    <span className="font-bold">{`Mobile2 ${t("Support")}`}</span>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/home") }}>{t("Home")}</a>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/faq") }}>{t("FAQ")}</a>
                </div>

            </div>
        </div>
    )
}


export const MemberFooter = () => {
    const { t } = useTranslation('common')
    const navigator = useNavigate()

    return (
        <div className="flex flex-col w-full text-gray-500 dark:text-gray-400">
            <div className="divider mt-0 pt-0"></div>
            <div className="md:px-10 px-3 py-5 flex flex-wrap justify-between gap-10 sm:grid sm:grid-cols-3">
                <FooterMobile2Main />

                <div className="order-3 sm:order-2 self-end min-w-max place-self-center flex flex-col justify-center items-center gap-1 text-xs w-full">
                    <span>Copyright M2 © 2025 FIBER SOFTWARE - FZCO</span>
                    <span>VENDSOFT SOFTWARE LTD© - info@vend.com.tr</span>
                </div>

                <div className="order-2 sm:order-3 min-w-32 justify-self-end flex flex-col gap-1">
                    <div className="h-[40px]"></div>
                    <span className="font-bold">{`Mobile2 ${t("Support")}`}</span>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/member/home") }}>{t("Home")}</a>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/member/create-ticket") }}>{t("Create Ticket")}</a>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/member/ticket-history") }}>{t("Ticket History")}</a>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/member/faq") }}>{t("FAQ")}</a>
                </div>

            </div>
        </div>
    )
}


export const AdminFooter = () => {
    const { t } = useTranslation('sidebar')
    const navigator = useNavigate()
    const { hasPermission } = useContext(PermissionContext)

    return (
        <div className="flex flex-col w-full text-gray-500 dark:text-gray-400">
            <div className="divider mt-0 pt-0"></div>
            <div className="md:px-10 px-3 py-5 flex flex-wrap justify-between gap-10 sm:grid sm:grid-cols-3">
                <FooterMobile2Main />

                <div className="order-3 sm:order-2 self-end min-w-max place-self-center flex flex-col justify-center items-center gap-1 text-xs w-full">
                    <span>Copyright M2 © 2025 FIBER SOFTWARE - FZCO</span>
                    <span>VENDSOFT SOFTWARE LTD© - info@vend.com.tr</span>
                </div>

                <div className="order-2 sm:order-3 min-w-32 justify-self-end flex flex-col gap-1">
                    <div className="h-[40px]"></div>
                    <span className="font-bold">{`Mobile2 ${t("Support", { ns: "common" })}`}</span>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/admin/dashboard") }}>{t("Dashboard")}</a>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/admin/ticket") }}>{t("Tickets")}</a>
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/admin/notifications") }}>{t("Notifications")}</a>
                    {
                        hasPermission("members:view") &&
                        <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/admin/members") }}>{t("Players")}</a>
                    }
                    {
                        hasPermission("users:view") &&
                        <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/admin/users") }}>{t("Users")}</a>
                    }
                    {
                        hasPermission("setup:view") &&
                        <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/admin/setup") }}>{t("Setup")}</a>
                    }
                    <a className="cursor-pointer text-sm hover:underline" onClick={() => { navigator("/admin/settings") }}>{t("Settings")}</a>
                </div>

            </div>
        </div>
    )
}


const FooterMobile2Main = () => {
    const { t } = useTranslation('common')

    return (
        <div className="order-1 sm:order-1 flex flex-col gap-1 items-center max-w-max">
            <a className="block h-[40px] cursor-pointer"
                href="https://mobile2.global"
            >

                <img
                    src={logo}
                    alt="Home"
                    className=""
                    width="120"
                />
            </a>
            <div className="flex flex-col min-w-max gap-1">

                <span className="font-bold">Mobile2 Global</span>
                <a className="text-sm hover:underline" href="https://mobile2.global/home">{t("Home")}</a>
                <a className="text-sm hover:underline" href="https://mobile2.global/thegame">{t("footer_about_game")}</a>
                <a className="text-sm hover:underline" href="https://mobile2.global/login">{t("Login")}</a>
                <a className="text-sm hover:underline" href="https://www.instagram.com/mobile2official/">{t("Instagram")}</a>
                <a className="text-sm hover:underline" href="https://discord.gg/y2vFvpgK5B">{t("Discord")}</a>
                <a className="text-sm hover:underline" href="https://www.tiktok.com/@mobile2official">{t("TikTok")}</a>
            </div>
        </div>
    )
}